import {
  GetFacilitiesRequest,
  GetFacilitiesResponse,
  RQUseQueryOptions,
  useGetFacilitiesQuery,
} from '@schooly/api';
import { useMemo } from 'react';

import { categorizeFacilities, sortFacilities } from './utils';

export const useFacilities = (
  params: GetFacilitiesRequest,
  options?: RQUseQueryOptions<GetFacilitiesResponse>,
) => {
  const response = useGetFacilitiesQuery(params, options);

  const sortedFacilities = useMemo(
    () => sortFacilities(response.data?.facilities ?? []),
    [response.data?.facilities],
  );

  const categorized = useMemo(() => categorizeFacilities(sortedFacilities), [sortedFacilities]);

  const counts = useMemo(
    () => ({
      campus: categorized.campuses.length,
      building: categorized.buildings.length,
      room: categorized.rooms.length,
    }),
    [categorized],
  );

  return {
    ...response,
    facilities: sortedFacilities,
    ...categorized,
    counts,
  };
};
